/**
 * Stage L cosmetics live in the upper rows of the 256x256 palette texture (render/palette.ts uses
 * the rows from 0 for player colours; ids stay far below COSM_CODE_ROW * 256). Per player id:
 *   code row   (COSM_CODE_ROW + (id >> 8))   R = border pattern (1-based, 0 none)
 *                                            G = fill texture (low 4 bits, 1-based) | strength << 4
 *   accent row (COSM_ACCENT_ROW + (id >> 8)) RGB = border pattern accent
 *   border row (COSM_BORDER_ROW + (id >> 8)) RGB = colour-set border colour, A = 255 when set
 */
export const COSM_CODE_ROW = 128;
export const COSM_ACCENT_ROW = 170;
export const COSM_BORDER_ROW = 212;
/** Players with an id up to this value can wear map cosmetics (42 rows of 256). */
export const COSM_MAX_ID = 42 * 256 - 1;
